import React, { useEffect, useState, useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { Spinner, Card } from "react-bootstrap";

const GraficoOrdiniOggi = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const ordini = data?.ORDINI_OGGI?.flat() || [];

        const contaOF4G = ordini.filter((item) => item.tipo_doc === "OF4G").length;
        const contaAltri = ordini.length - contaOF4G;

        setDataGrafico([
          { name: "Urgenti (OF4G)", value: contaOF4G, color: "#b81f25" }, // Rosso Brand
          { name: "Standard / Altri", value: contaAltri, color: "#e9ecef" }, // Grigio chiaro moderno
        ]);

        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch grafico:", err);
        setLoading(false);
      });
  }, []);

  // Calcolo del totale per visualizzarlo al centro della ciambella
  const totale = useMemo(() => dataGrafico.reduce((acc, curr) => acc + curr.value, 0), [dataGrafico]);

  if (loading) {
    return (
      <Card className="border-0 shadow-sm d-flex justify-content-center align-items-center" style={{ height: '400px', borderRadius: '15px' }}>
        <Spinner animation="grow" variant="danger" />
      </Card>
    );
  }

  return (
    <Card className="border-0 card shadow-lg overflow-hidden" style={{ borderRadius: '16px', height: '400px', background: '#fff' }}>
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-bold text-secondary" style={{ letterSpacing: '0.5px', fontSize: '0.75rem' }}>
          DISTRIBUZIONE ORDINI OGGI
        </h6>
      </div>

      <div style={{ position: 'relative', height: '280px', width: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={dataGrafico}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={95}
              paddingAngle={8}
              dataKey="value"
              stroke="none"
              cornerRadius={6} // Angoli arrotondati sulle fette
            >
              {dataGrafico.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} style={{ outline: 'none' }} />
              ))}
            </Pie>
            <Tooltip 
              cursor={{ fill: 'transparent' }}
              contentStyle={{ 
                borderRadius: '12px', 
                border: 'none', 
                boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                fontSize: '0.8rem'
              }}
            />
          </PieChart>
        </ResponsiveContainer>

        {/* Testo centrale alla ciambella */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}>
          <span style={{ fontSize: '0.7rem', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase' }}>Totale</span>
          <h2 className="m-0 fw-bold" style={{ color: '#212529', lineHeight: '1' }}>{totale}</h2>
        </div>
      </div>

      {/* Legenda Custom Modernizzata */}
      <div className="px-4 pb-4 mt-auto">
        <div className="d-flex justify-content-between gap-2">
          {dataGrafico.map((item, i) => (
            <div key={i} className="d-flex flex-column align-items-center flex-fill p-2 rounded-3" style={{ background: '#f8f9fa' }}>
              <div className="d-flex align-items-center mb-1">
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: item.color, marginRight: '6px' }}></div>
                <span style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6c757d' }}>{item.name}</span>
              </div>
              <span className="fw-bold" style={{ fontSize: '0.9rem' }}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default GraficoOrdiniOggi;